import axios from 'axios'
import laroute from '~/laroute'
// import store from '~/store'

export const state = {
  sortColumns: [],
  pdf: undefined
}

export const getters = {
  sortColumns: state => state.sortColumns,
  pdf: state => state.pdf
}

export const mutations = {
  SORT_COLUMNS (state, data) {
    state.sortColumns = data
  },

  PDF (state, data) {
    state.pdf = data
  }
}

export const actions = {
  async getCSGSortColumns ({ commit }, data) {
    const response = await axios.get(laroute.route('get-csg-reports-sort-columns'), {
      params: {
        name: data
      }
    })

    commit('SORT_COLUMNS', response.data)
  },

  async checkGenerateReportParams ({ commit }, { data }) {
    if (data.hasOwnProperty('group') && data.group === 'csg') {
      await axios.get(laroute.route(data.name + '-report-params', { companyAbbr: this.getters['auth/company'], ...data }))
      return
    }
    await axios.get(laroute.route('check-generate-report-params', { companyAbbr: this.getters['auth/company'], ...data }))
  },

  async generateReport ({ commit }, { data }) {
    await axios.get(laroute.route('generate-report', { companyAbbr: this.getters['auth/company'], ...data }), { responseType: 'arraybuffer' })
      .then((res) => {
        commit('PDF', res.data)
      })
  },

  async generateBlanketReleaseHistoryReport ({ commit }, { data }) {
    await axios.get(laroute.route('generate-blanket-release-history-report', { companyAbbr: this.getters['auth/company'], ...data }), { responseType: 'arraybuffer' })
      .then((res) => {
        commit('PDF', res.data)
      })
      .catch((err) => {
        if (err.response.status === 422) {
          // What is going on? We extract errors extracted from  binary answer and converted to JSON object
          err.response.data.errors = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data))).errors
          throw err
        }
      })
  },

  async generateBlanketReplenishmentReport ({ commit }, { data }) {
    await axios.get(laroute.route('generate-blanket-replenishment-report', { companyAbbr: this.getters['auth/company'], ...data }), { responseType: 'arraybuffer' })
      .then((res) => {
        commit('PDF', res.data)
      })
      .catch((err) => {
        if (err.response.status === 422) {
          // What is going on? We extract errors extracted from  binary answer and converted to JSON object
          err.response.data.errors = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data))).errors
          throw err
        }
      })
  },

  async generateBlanketPlanningReport ({ commit }, { data }) {
    await axios.post(laroute.route('generate-blanket-planning-report', { companyAbbr: this.getters['auth/company'] }), { ...data }, { responseType: 'arraybuffer' })
      .then((res) => {
        commit('PDF', res.data)
      })
      .catch((err) => {
        if (err.response.status === 422) {
          // What is going on? We extract errors extracted from  binary answer and converted to JSON object
          err.response.data.errors = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data))).errors
          throw err
        }
      })
  },

  async generateSOStatusReport ({ commit }, { data }) {
    await axios.get(laroute.route('generate-so-status-report', { companyAbbr: this.getters['auth/company'], ...data }), { responseType: 'arraybuffer' })
      .then((res) => {
        commit('PDF', res.data)
      })
      .catch((err) => {
        if (err.response.status === 422) {
          // What is going on? We extract errors extracted from  binary answer and converted to JSON object
          err.response.data.errors = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data))).errors
          throw err
        }
      })
  },

  async generateSupplyDemandSummaryReport ({ commit }, { data }) {
    await axios.get(laroute.route('generate-supply-demand-summary-report', { companyAbbr: this.getters['auth/company'], ...data }), { responseType: 'arraybuffer' })
      .then((res) => {
        commit('PDF', res.data)
      })
      .catch((err) => {
        if (err.response.status === 422) {
          // What is going on? We extract errors extracted from  binary answer and converted to JSON object
          err.response.data.errors = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data))).errors
          throw err
        }
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/reports.js